import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {DropdownService} from "../../services/dropdown.service";
import {
  BallisticRecord,
  icJWT_Account,
  IncidentRecord,
  LabInfo, LinkReportIncidentReq, NIBIN_AdditionalInfoEvidence,
  ReportRecord, TriggerAssociatedIncidentsType,
  WeaponRecord
} from "../../NIBINInterface";
import {AuthService} from "../../services/auth.service";
import {ReportService} from "../../services/report.service";
import {DownloadService} from "../../services/download.service";
import {NewIncidentFormComponent} from "../../dashboard/incidents/new-incident-form/new-incident-form.component";
import Swal from "sweetalert2";
import {MatDialog} from "@angular/material/dialog";
import {IncidentService} from "../../services/incident.service";


@Component({
  selector: 'app-report-preview',
  templateUrl: './report-preview.component.html',
  styleUrls: ['./report-preview.component.css'],
  providers: [DropdownService, DownloadService]
})
export class ReportPreviewComponent implements OnInit {
  @Input('incidents') incidents : IncidentRecord[] = [];
  @Input('ReportInfo') ReportInfo : ReportRecord = <ReportRecord>{NIBINHit:false};
  @Input('labsn') labsn : string = "";

  @Input('showDelete') showDelete:boolean=false;
  @Input('isEditable') isEditable:boolean=false;

  @Output() removeIncident = new EventEmitter<IncidentRecord>();
  @Output() TriggerAssociatedIncidents = new EventEmitter<TriggerAssociatedIncidentsType>();
  user: icJWT_Account = <icJWT_Account>{};
  fullLabName: string = "";
  LabImg: string = "";
  LabState: string = "";

  constructor(private authService: AuthService,private dropdownService: DropdownService, private reportService:ReportService, private incidentService:IncidentService, private downloadService:DownloadService, public dialog: MatDialog) {
    this.user = this.authService.getUser()

  }

  ngOnInit(): void {
    if(this.labsn == "")
      this.labsn=this.user.CurrentDept
    this.loadDeptImg()


    this.GenerateAdditionalInfoEvidence()

  }

  GenerateAdditionalInfoEvidence(){

    if(this.incidents) {
      this.incidents.sort(this.reportService.sortReportsIncidents)
      for (let i of this.incidents) {
        i.RPT_AdditionalInfoEvidence = this.reportService.makeIncidentEvidenceLines(i)
      }
    }

  }


  async loadDeptImg(): Promise<void>{
    if(this.labsn){
      let  lab: LabInfo = await this.dropdownService.getLabInfo(this.labsn);
      this.LabImg=lab.LAB_IMAGE;
      this.fullLabName=lab.LAB_FN;
      this.LabState = lab.LAB_STATE;
    }
  }

  TriggerCheckForOtherAssociatedIncidents(SelectedForAssoc: any, ID: any, Type: any) {
    //Rebuild the Incidents Evidence Line(s) to the selected is always on top.
    if(this.incidents){
      this.reportService.updateEvidenceMasters(this.incidents)
      for(let i of this.incidents){
        i.RPT_AdditionalInfoEvidence = this.reportService.makeIncidentEvidenceLines(i)
      }

      if(SelectedForAssoc){
        this.TriggerAssociatedIncidents.emit({ID: ID, EType: Type})
      }
    }
  }

  DownloadPDFSIncidentID(incident: IncidentRecord) {
    if(incident.IncidentID)
      this.downloadService.DownloadNIBINReportsByIncidentID(incident.IncidentID)
  }

  editIncidentDialog(incident:IncidentRecord) {
    let dia = this.dialog.open(NewIncidentFormComponent, {
      width: '80%',
      height: '80%',

    })

    dia.componentInstance.data=this.incidentService.prepareEditIncident(incident);

    dia.componentInstance.IncidentCreated.subscribe((val)=>{

      this.incidentService.saveEditIncToDB(val).then(r=>{
        dia.close();
        Swal.fire({
          icon: 'success',
          title: 'System Notification',
          text: "Successfully Saved Changes to Incident Record",
          timerProgressBar:true,
          timer:4000
        })

        let idx = this.incidents.indexOf(incident)
        let OldVersion:IncidentRecord = JSON.parse(JSON.stringify(this.incidents[idx]))

        this.incidents.splice(idx,1)
        this.incidents.push(r)
        this.incidents.sort(this.reportService.sortReportsIncidents)

        //Now use the old copy to highlight the new copy
        if(OldVersion.Weapon && r.Weapon){
          for(let wOld of OldVersion.Weapon){
            for(let wNew of r.Weapon){
              if(wOld.ID === wNew.ID)
                wNew.SelectedForAssoc = wOld.SelectedForAssoc
            }

          }
        }
        if(OldVersion.Ballistics && r.Ballistics){
          for(let bOld of OldVersion.Ballistics){
            for(let bNew of r.Ballistics){
              if(bOld.ID === bNew.ID)
                bNew.SelectedForAssoc = bOld.SelectedForAssoc
            }
          }
        }

        this.GenerateAdditionalInfoEvidence()
      })

    })

  }

  getIncidentDateOfSubmission(incident: IncidentRecord) : string | null {
    let dtoOfSubmission : any = null
    if(incident.Ballistics) {
      for (let b of incident.Ballistics) {
        if(b.SelectedForAssoc){
          dtoOfSubmission = b.DTOFSUBMISSION
        }
      }
    }

    //Weapon if selected will always override the ballistics in the incident date of submission
    if(incident.Weapon) {
      for (let w of incident.Weapon) {
        if(w.SelectedForAssoc){
          dtoOfSubmission = w.DTOFSUBMISSION
        }
      }
    }


    return dtoOfSubmission
  }

  isIncidentPrimaryCheckboxDisabled(incident: IncidentRecord) {
    let c:number=0;

    if(this.incidents)
        for(let i of this.incidents)
          if(i.SelectedAsPrimary)
            c++
    return (c > 0 && !incident.SelectedAsPrimary);
  }

  isEvidenceAssocTypeDisabled(incident: IncidentRecord, evidence: NIBIN_AdditionalInfoEvidence) {
    return !!evidence.SelectedForAssoc;
  }

  isEvidenceCheckboxDisabled(I: IncidentRecord, evidence: NIBIN_AdditionalInfoEvidence) {
    let c:number=0;

    if(evidence.EV_Type && evidence.EV_Type==="BALLISTIC"){
      let bRecords = I.RPT_AdditionalInfoEvidence?.filter(x => x.EV_Type === "BALLISTIC")
      if(bRecords)
        for(let b of bRecords)
          if(b.SelectedForAssoc)
            c++
    }
    if(evidence.EV_Type && evidence.EV_Type==="WEAPON"){
      for(let I of this.incidents)
        if(I.RPT_AdditionalInfoEvidence)
          for(let w of I.RPT_AdditionalInfoEvidence.filter(x=> x.EV_Type==='WEAPON'))
            if(w.SelectedForAssoc)
              c++
    }


    return (c > 0 && !evidence.SelectedForAssoc);

  }
  isEvidenceSuppressed(I: IncidentRecord, evidence: NIBIN_AdditionalInfoEvidence, isOverRide: boolean | null) {
    //We need to suppress weapon records that are not associated in a report. If there is no weapon selected we show all weapons so one can be selected
    let c:number=0;

    if(isOverRide){
      return false;
    }

    if(evidence){
      if(evidence.EV_Type && evidence.EV_Type==="BALLISTIC"){
        return false;
      }

      if(evidence.EV_Type && evidence.EV_Type==="WEAPON"){
        for(let I of this.incidents)
          if(I.RPT_AdditionalInfoEvidence)
            for(let w of I.RPT_AdditionalInfoEvidence.filter(x=> x.EV_Type==='WEAPON'))
              if(w.SelectedForAssoc)
                c++
      }
    }

    return (c > 0 && !evidence.SelectedForAssoc);

  }

  ReportGunRecoveredType() : boolean {
    let result:boolean = false;

    if(this.incidents){
      for(let i of this.incidents){
        if(i.Weapon){
          for(let w of i.Weapon){
            if(w.SelectedForAssoc)
              result=true;
          }
        }
      }
    }

    return result;
  }
}
